<!-- eslint-disable prettier/prettier -->
<template>
    <div>
      <b-container fluid>
        <b-row>
          <b-col class="col-lg-12 mt-lg-5 mt-xs-3 p-2">
            <div class="tab-wrapper">
              <div @click="activeTab = 'UserProfile'" :class="{ 'tab-item-active' : activeTab == 'UserProfile'}" class="tab-item">
                User Profile
              </div>
              <div @click="activeTab = 'OrganizationProfile'" :class="{ 'tab-item-active' : activeTab == 'OrganizationProfile'}" class="tab-item">
                Organization Profile
              </div>
            </div>

            <div class="">
              <organization-tab v-if="activeTab == 'OrganizationProfile'" />
              <user-tab v-if="activeTab == 'UserProfile'" />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </template>
  
  <script>
  import { mapState, mapActions } from "vuex";
  import axios from "axios";
  import OrganizationTab from './tabs/OrganizationTab.vue';
  import UserTab from './tabs/UserTab.vue';
  
  export default {
    components: {
      OrganizationTab,
      UserTab
    },
    mounted() {
      // this.setImageDirectory("profileimages")
  
      this.setCurrentModule("Profile");
      //Update the User Object with initial values from the Details on last logged in.
  
      (this.profileimagelink = this.$store.state.loginmaster.details.profileimage),
        (this.user = {
          fname: this.$store.state.loginmaster.details.fname,
          lname: this.$store.state.loginmaster.details.lname,
          email: this.$store.state.loginmaster.details.email,
          phone: this.$store.state.loginmaster.details.phone,
          city: this.$store.state.loginmaster.details.city,
          state: this.$store.state.loginmaster.details.state,
          profileimage: this.$store.state.loginmaster.details.profileimage,
        });
  
      // Grab the Institutions names from the institution object and update the institution array of the Data Property
      let inst = this.allinsti.map((x) => x.name);
      this.instiarr = inst;
    },
  
    data() {
      return {
        saving: false,
        user: this.getForm(),
        instiarr: [],
        profileimagelink: "",
        uploadingprofileimage: false,
        discarding: false,
        showcopy: false,
        showcopy2: false,
        deletingAccount: false,
        activeTab : "UserProfile"
      };
    },
    methods: {
      ...mapActions("dashboard", ["saveUserProfile"]),
      ...mapActions("admin", ["setCurrentModule"]),
      ...mapActions("loginmaster", ["updateDetails", "deleteUserAccount", "logOut"]),
      triggerFileClick() {
        this.$refs.photo.click();
      },
      // Get the Contents of the Submitted form in an Object
      getForm() {
        return {
          fname: this.$store.state.loginmaster.details.fname,
          lname: this.$store.state.loginmaster.details.lname,
          email: this.$store.state.loginmaster.details.email,
          phone: this.$store.state.loginmaster.details.phone,
          city: this.$store.state.loginmaster.details.city,
          state: this.$store.state.loginmaster.details.state,
          profileimage: this.$store.state.loginmaster.details.profileimage,
          category: "",
          institution: "",
          duration: "",
          datestarted: "",
        };
      },
  
      deleteAccount() {
        this.deletingAccount = true;
  
        this.deleteUserAccount().then(() => {
          this.deletingAccount = false;
  
          this.logOut().then(() => {
            this.$router.push({
              name: "login",
            });
          });
        });
      },
  
      discardChanges() {
        (this.profileimagelink = this.$store.state.loginmaster.details.profileimage),
          (this.user = {
            fname: this.$store.state.loginmaster.details.fname,
            lname: this.$store.state.loginmaster.details.lname,
            email: this.$store.state.loginmaster.details.email,
            phone: this.$store.state.loginmaster.details.phone,
            city: this.$store.state.loginmaster.details.city,
            state: this.$store.state.loginmaster.details.state,
            profileimagelink: this.$store.state.loginmaster.details.profileimage,
          });
        // this.user.fname = this.userdet.fname
        // this.user.lname = this.userdet.lname
        // this.user.email = this.userdet.email
        // this.user.phone = this.userdet.phone
        // this.user.city = this.userdet.city
        // this.user.state = this.userdet.state
      },
  
      handleImage() {
        this.uploadingprofileimage = true;
        let profileimage = this.$refs.photo.files[0];
        let formData = new FormData();
        formData.append("image", profileimage);
        formData.append("environment", this.environ);
        formData.append("origin", this.origin);
        formData.append("pretag", "profileimage");
        let apilink = `${this.api_origin}/ImageHandler.php`;
  
        axios
          .post(apilink, formData, {
            header: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.uploadingprofileimage = false;
            this.$bvModal
              .msgBoxOk("Image Uploaded Successfully.", {
                title: "Image Uploaded",
                size: "xs",
                centered: true,
              })
              .then(() => {});
            // console.log(response.data);
            //this.setFile(response.data.url);
            this.profileimagelink = response.data.url;
            this.user.profileimage = response.data.url;
          })
          .catch(() => {
            this.$bvModal
              .msgBoxOk("Check your Network Connection. Could not upload Image.", {
                title: "No Network Connection",
                size: "xs",
                centered: true,
              })
              .then(() => {
                this.uploadingprofileimage = false;
              });
            //console.log(error);
          });
      },
  
      saveProfile() {
        this.saving = true; // Update the saving status to true. This triggers on the roller overlay over the button and disables the button.
  
        // Call the saveUserProfile from the Store's action and pass the user object to it
        return this.saveUserProfile(this.user).then(() => {
          // After the request has been made and a response received. change the saving status to false to release the button and trigger off the roller.
          this.saving = false;
          this.updateDetails();
  
          // Send a Modal alert telling the User that the Profile has been saved Successfully.
          this.$bvModal
            .msgBoxOk("Your Profile has been updated Successfully.", {
              title: "Profile Updated",
              size: "xs",
              centered: true,
            })
            .then(() => {});
        });
      },
      copylink() {
        navigator.clipboard.writeText(
          `${this.origin}/signup/?ref=${this.$store.state.loginmaster.details.refcode}`
        );
        this.showcopy = true;
      },
      copylink2() {
        navigator.clipboard.writeText(`${this.$store.state.loginmaster.details.refcode}`);
        this.showcopy2 = true;
      },
    },
    computed: {
      ...mapState({
        userdet: (state) => state.loginmaster.details,
        plan: (state) => state.loginmaster.details.plan,
        premium: (state) => state.loginmaster.details.premium_details,
        allinsti: (state) => state.admin.listinstitutions,
        environ: (state) => state.loginmaster.environ,
        origin: (state) => state.loginmaster.site_origin,
        api_origin: (state) => state.loginmaster.api_origin,
      }),
    },
  };
  </script>
  
  <style scoped>
  .fo-pro {
    width: 100%;
  }
  
  .secll {
    font-weight: bold;
    font-size: 1.1rem;
  }
  
  .profile-wrap {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
  }
  .text-profile {
    width: 100%;
  }
  .picture-profile {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    width: 100%;
  }
  
  .profile-image {
    width: 200px;
    height: 200px;
    display: inline-block;
    border-radius: 10px 10px;
  }
  .profile-photo-input {
    font-size: 2rem;
    font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
    border: 0px;
    border-radius: 0px;
    height: 10rem;
    display: none;
  }
  
  .v-button {
    border-radius: 10px 10px;
    height: 3rem;
    background-color: white;
    font-weight: bolder;
    color: black;
    position: relative;
    bottom: -80%;
    border: 1px solid #00984a;
    font-size: 14px;
  }
  .v-button:hover {
    background-color: white;
    color: #00984a;
    border: 1px solid #00984a;
  }
  
  .v-button2 {
    border-radius: 10px 10px;
    height: 3rem;
    background-color: #00984a;
    font-weight: bolder;
    color: white;
    position: relative;
    bottom: -80%;
    border: 0px;
    font-size: 14px;
  }
  .v-button2:hover {
    background-color: white;
    color: #00984a;
    border: 1px solid #00984a;
  }
  .copyinline {
    background-color: #000000;
    color: white;
    display: inline-flex;
    overflow: auto;
    scrollbar-width: thin;
    border-radius: 10px 10px;
  }
  
  .copyicon {
    width: 10%;
    cursor: pointer;
    left: -100px;
  }
  
  .copytext {
    width: 90%;
    overflow: auto;
    scrollbar-width: thin;
  }
  
  .copier {
    position: absolute;
    left: -9999px;
  }
  .copied {
    position: relative;
    left: -10px;
    font-size: 0.7rem;
  }
  
  .delete-class {
    color: red;
    margin-top: 50px;
    cursor: pointer;
    font-size: 24px;
  }

  .tab-wrapper{
    display : flex;
    flex-wrap : wrap;
    gap: 20px;
    padding-bottom: 10px;
  }

  .tab-item{
    font-size: 18px;
    padding-bottom: 10px;
    cursor :pointer;
    font-weight: bold;
  }

  .tab-item-active{
    border-bottom: 3px solid #243057;
  }
  
  @media screen and (max-width: 999px) {
    .fo-pro {
      width: 100%;
      margin-left: 0px;
    }
    .picture-profile {
      width: 100%;
    }
    .text-profile {
      width: 100%;
    }
    .v-button {
      font-size: 0.8rem;
    }
    .v-button2 {
      font-size: 0.8rem;
    }
  }
  </style>
  